import '@/scss/pages/editorial-team-single.scss'
import { useSidebarBottom } from '@/js/common/sidebar-bottom'

import header from '../layout/header'
import videoResponsive from '../common/video-responsive'
import anchor from '../common/anchor'
import publicationsLoadMore from '../section/teacher/load-more'
import { bannerCta, bannerWide } from '../common/banners'
import manageClassName from '../helpers/manage-class'

document.addEventListener('DOMContentLoaded', function () {
  header()
  videoResponsive()
  publicationsLoadMore()
  anchor()
  bannerWide()
  bannerCta()
  manageClassName('iframe', 'iframe-formatting', 'add')
  useSidebarBottom()
})
